"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Text;

var _Text = require("@adobe/react-spectrum-workflow/dist/Text");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function Text(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_Text.A4uText, null));
}